import React from 'react'
import styled from 'styled-components'


const Container = styled.div`
    padding: 10px 0px 10px 0px;
    display: flex;
    justify-content: center;
    background-color: #444;
    color: white;
    padding: 3rem;
    @media(min-width: 1024px) {
        padding-top: 3rem;
        padding-right: 10rem;
        padding-left: 10rem;
    }

    p {
        font-size: 0.9rem;
    }
`;

export const FacebookMessage = (props) => {
  return (
    <Container>
        <p>
            {props.facebook_message}
        </p>
    </Container>
  )
}
